import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@mui/material";
import { useRef, useState } from "react";
import importInstruction from "./importinstruction.png";

interface ImportCsvDialogProps {
  open: boolean;
  onClose: () => void;
  onImportCsv: (file: File) => void;
}

export default function ImportCsvDialog({
  open,
  onClose,
  onImportCsv,
}: ImportCsvDialogProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File>();
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    const selectedFiles = files as FileList;
    setFile(selectedFiles?.[0]);
  };

  const handleSendInvite = () => {
    if (!file) return;
    setLoading(true);
    onImportCsv(file);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true}>
      {loading ? <LinearProgress></LinearProgress> : null}
      <DialogTitle>Import CSV file</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1">
          Invite users by uploading a CSV file.
        </Typography>
        <input
          style={{ display: "none" }}
          ref={inputRef}
          type="file"
          accept=".csv"
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          color="primary"
          component="span"
          onClick={() => inputRef.current!.click()}
        >
          Upload CSV file
        </Button>
        {file && <>&nbsp;{file.name}</>}
        <Box sx={{ border: 1, p: 1, mt: 1 }}>
          <b>Import instructions:</b>
          <br />
          Create or export comma-separated file (CSV) listing the user first
          name, last name and email address to import.
          <ul>
            <li>Add one row for each new user.</li>
            <li>Separators must be semicolon.</li>
            <li>
              Header row is mandatory. Column header name must be the same as
              shown below. The order of the columns does not matter.
            </li>
          </ul>
          <img src={importInstruction} alt="Import instruction" />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="outlined" disabled={!file} onClick={handleSendInvite}>
          Send invite
        </Button>
      </DialogActions>
    </Dialog>
  );
}
